import BottomMenu from "./BottomMenu";
import BottomButton from "./BottomButton";
import { Button, Grid, Box, BottomNavigationAction } from "@mui/material";
import BuyLoggedOut from './BuyLoggedOut';
import Test1 from './Test1';
import { useEffect, useState } from "react";
import axios from 'axios';
import { loginState, configState } from "../lib/State";

function Buy() {

  const [loaded, setLoaded] = useState(false);
  const [login, setLogin] = useState(loginState);
  const token = localStorage.getItem("token");

  const get_session = async() => {
    const cid = configState.cid;
    let result = await axios.post(configState.api+"/gympass/get_session", { token: token, cid:cid });
    if(result.data.mcd!=='' && result.data.success===1) {
      setLogin({ mcd: result.data.mcd, level: result.data.level });
    }    
    setLoaded(true);
  }
  
  useEffect(()=>{
    get_session();
  },[]);
  
  return (
    <Grid container height="85vh" direction="column">      
      {/* <Grid
        style={{
          width: "100%",
          padding: "5px",
          fontSize: "20px",
          background: "#0092a2",
          color: "white",
          position: "fixed",
        }}
      >
        쿠폰구입
      </Grid> */}
        { loaded && 
          <>
            {login.mcd === '' || login.mcd === undefined ?
            <BuyLoggedOut /> :
            <Test1 login={login}/> }
          </>
        }
      <BottomButton login={login} loaded={loaded}/>
      <BottomMenu active="buy" />
    </Grid>
  );
}

export default Buy;
